<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <!-- Welcome Section -->
      <v-flex xs12>
        <v-card class="mb-0 pa-3">
          <v-layout row class="py-3" justify-start>
            <v-img :src="logo" style="max-width: 70px;" class="mx-3" />
            <div>
              <div class="display-1 my-0 pt-1 ml-1">
                UTA User Portal Dashboard
              </div>
              <div class="body-1" style="padding-top: 3px; margin-left: 6px;">
                User: {{ user }}
              </div>
            </div>

            <v-spacer></v-spacer>
          </v-layout>
          <!-- <v-card-text class="mb-0 pb-2 pt-0">
                        <p>
                            Here’s a quick overview of your tickets and shared
                            files.
                        </p>
                    </v-card-text> -->
        </v-card>
      </v-flex>

      <!-- Tickets Section -->
      <v-flex xs6>
        <v-card class="mb-0 pb-3">
          <v-card-title class="pb-1 pt-2" primary-title>
            <v-icon color="success" class="mr-2"
              >mdi-help-circle-outline</v-icon
            >
            <h4 class="card-title font-weight-medium">
              IT Help Desk
            </h4>
          </v-card-title>
          <div style="border: #5cb860 1px solid" class="mx-3">
            <div
              class="white--text px-2 py-1 subheading-2"
              style="background-color: #5cb860;"
            >
              Support Tickets
            </div>

            <v-card-text class="mx-3 mt-2">
              <v-layout row class="mb-2 pt-1">
                <div class="font-weight-medium mr-2">
                  Open Tickets:
                </div>
                <v-progress-linear
                  :indeterminate="true"
                  class="ml-1 dashboard-loading"
                  height="2"
                  v-if="openTicketsCountLoading"
                ></v-progress-linear>
                <div v-if="!openTicketsCountLoading">
                  <a href="/helpdesk/requests">{{ openTicketsCount }}</a>
                </div>
              </v-layout>
              <v-layout row class="mb-2 pt-1">
                <div class="font-weight-medium mr-2">
                  On Hold Tickets:
                </div>
                <v-progress-linear
                  :indeterminate="true"
                  class="ml-1 dashboard-loading"
                  height="2"
                  v-if="onHoldTicketsCountLoading"
                ></v-progress-linear>
                <div v-if="!onHoldTicketsCountLoading">
                  <a href="/helpdesk/requests">{{ onHoldTicketsCount }}</a>
                </div>
              </v-layout>
              <v-layout row class="mb-0">
                <div class="font-weight-medium mr-2">
                  Closed Tickets:
                </div>
                <v-progress-linear
                  :indeterminate="true"
                  class="ml-1 dashboard-loading"
                  height="2"
                  v-if="closedTicketsCountLoading"
                ></v-progress-linear>
                <div v-if="!closedTicketsCountLoading">
                  <a @click="goToClosedTickets">{{ closedTicketsCount }}</a>
                </div>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pb-3">
              <v-btn color="success" small :to="{ name: 'HelpDeskRequests' }">
                View Tickets
              </v-btn>
              <v-btn
                color="success"
                small
                :to="{
                  name: 'HelpDeskRequests',
                  query: {
                    openNewTicket: true,
                  },
                }"
              >
                New Ticket
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-flex>

      <!-- Shared Files + Pay UTA stacked in the right column -->
      <v-flex xs6 class="right-dashboard-col">
        <div class="right-dashboard-stack">
          <!-- Shared Files -->
          <v-card class="shared-files-card">
            <v-card-title class="pb-1 pt-2" primary-title>
              <v-icon class="mr-2" color="success">mdi-file-move</v-icon>
              <h4 class="card-title font-weight-medium">
                Users Shared Files
              </h4>
            </v-card-title>
            <v-card-text class="mx-3">
              <v-layout row class="mb-2">
                <div class="font-weight-medium mr-2">
                  Files Shared With You:
                </div>
                <v-progress-linear
                  :indeterminate="true"
                  class="ml-1 dashboard-loading"
                  height="2"
                  v-if="sharedWithYouCountLoading"
                ></v-progress-linear>
                <div v-if="!sharedWithYouCountLoading">
                  <a href="/files-shared-with-user">{{ sharedWithYouCount }}</a>
                </div>
              </v-layout>
              <v-layout row class="mb-2">
                <div class="font-weight-medium mr-2">
                  Files You Shared:
                </div>
                <v-progress-linear
                  :indeterminate="true"
                  class="ml-1 dashboard-loading"
                  height="2"
                  v-if="sharedByYouCountLoading"
                ></v-progress-linear>
                <div v-if="!sharedByYouCountLoading">
                  <a href="/shared-files">{{ sharedByYouCount }}</a>
                </div>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pb-3">
              <v-btn
                color="success"
                small
                :to="{ name: 'SharedFiles', query: { shareNewFile: true } }"
                class="mr-2"
              >
                Share New File
              </v-btn>
            </v-card-actions>
          </v-card>

          <!-- Pay UTA -->
          <v-card class="pay-uta-card px-3">
            <v-card-title class="pb-0 pt-0 px-0" primary-title>
              <v-icon class="mr-2" color="success">mdi-credit-card</v-icon>
              <h4 class="card-title font-weight-medium">
                Pay UTA
              </h4>
            </v-card-title>
            <v-card-actions class="ma-0 px-0 pt-1 pb-3">
              <v-btn
                color="success"
                class=""
                small
                :to="{ name: 'CustomPayment', query: { mode: 'basic' } }"
              >
                Make a Payment
              </v-btn>
            </v-card-actions>
          </v-card>

          <!-- Calendar -->
          <!-- <v-card class="pay-uta-card px-3 mt-2">
            <v-card-title class="pb-0 pt-0 px-0" primary-title>
              <v-icon class="mr-2" color="success">mdi-calendar</v-icon>
              <h4 class="card-title font-weight-medium">
                Calendar
              </h4>
            </v-card-title>
            <v-card-actions class="ma-0 px-0 pt-1 pb-3">
              <v-btn
                color="success"
                class=""
                small
                :to="{ name: 'Calendar' }"
              >
                View Calendar
              </v-btn>
            </v-card-actions>
          </v-card> -->
        </div>
      </v-flex>

      <!-- Parent Info Section -->
      <v-flex xs6>
        <v-card class="mb-4">
          <v-card-title class="pb-1 pt-2 ml-1" primary-title>
            <v-icon class="mr-2" color="success"
              >mdi-book-open-page-variant</v-icon
            >
            <h4 class="card-title font-weight-medium">
              חודש'ליכע עלטערן אינפארמאציע בלעטל
            </h4>
          </v-card-title>
          <v-card-text class="pt-3 mx-3 pl-0 pb-3">
            <v-layout row wrap class="mx-1 mb-2">
              <div
                v-for="(publication, index) in parentInfoPublications"
                :key="publication.id"
                class="width-400 pa-3 mr-1 mb-1"
                style="border: 1px solid rgba(0, 0, 0, .12);"
              >
                <v-layout
                  row
                  align-center
                  class="mx-3"
                  style="min-height: 60px;"
                >
                  <v-icon large class="" color="rgb(246, 32, 23)"
                    >mdi-file-pdf</v-icon
                  >
                  <v-spacer></v-spacer>
                  <div
                    class="title mx-3 text-xs-center"
                    style="max-width: 400px; margin-bottom: 0px !important;"
                  >
                    {{ publication.description }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-icon
                    large
                    class=""
                    color="rgb(246, 32, 23)"
                    @click="openPublication(publication)"
                    >mdi-eye</v-icon
                  >
                </v-layout>
              </div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- User manuals Section -->
      <v-flex xs6>
        <v-card class="mb-4">
          <v-card-title class="pb-1 pt-2 ml-1" primary-title>
            <v-icon class="mr-2" color="success"
              >mdi-book-open-page-variant</v-icon
            >
            <h4 class="card-title font-weight-medium">
              UTA User manuals
            </h4>
          </v-card-title>
          <v-card-text class="pt-3 mx-3 pl-0 pb-3">
            <v-layout row wrap class="mx-1 mb-2">
              <div
                v-for="(publication, index) in userManualsPublications"
                :key="publication.id"
                class="width-400 pa-3 mr-1 mb-1"
                style="border: 1px solid rgba(0, 0, 0, .12);"
              >
                <v-layout
                  row
                  align-center
                  class="mx-3"
                  style="min-height: 60px;"
                >
                  <v-icon large class="" color="rgb(246, 32, 23)"
                    >mdi-file-pdf</v-icon
                  >
                  <v-spacer></v-spacer>
                  <div
                    class="title mx-3 text-xs-center"
                    style="max-width: 400px; margin-bottom: 0px !important;"
                  >
                    {{ publication.description }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-icon
                    large
                    class=""
                    color="rgb(246, 32, 23)"
                    @click="openPublication(publication)"
                    >mdi-eye</v-icon
                  >
                </v-layout>
              </div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      logo: "https://utaw.blob.core.windows.net/images/logo+uta11.png",

      openTicketsCount: 0,
      onHoldTicketsCount: 0,
      closedTicketsCount: 0,
      sharedWithYouCount: 0,
      sharedByYouCount: 0,

      openTicketsCountLoading: true,
      onHoldTicketsCountLoading: true,
      closedTicketsCountLoading: true,
      sharedWithYouCountLoading: true,
      sharedByYouCountLoading: true,
      user: "",

      parentInfoPublications: [],
      userManualsPublications: [],
    };
  },
  created() {
    this.user = this.$store.state.authentication.user;

    this.loadDashboardInfo();
  },
  methods: {
    async loadDashboardInfo() {
      try {
        const info = await this.$http.get(
          "api/adminPortal/getDashboardInfo?user=" +
            this.$store.state.authentication.user
        );

        this.openTicketsCount = info.openRequests;
        this.onHoldTicketsCount = info.onHoldRequests;
        this.closedTicketsCount = info.closedRequests;
        this.sharedWithYouCount = info.filesSharedWithUser;
        this.sharedByYouCount = info.sharedFiles;
        this.parentInfoPublications = info.parentInfoPublications;
        this.userManualsPublications = info.userManualsPublications;

        this.openTicketsCountLoading = false;
        this.onHoldTicketsCountLoading = false;
        this.closedTicketsCountLoading = false;
        this.sharedWithYouCountLoading = false;
        this.sharedByYouCountLoading = false;
      } catch (e) {
        this.openTicketsCountLoading = false;
        this.onHoldTicketsCountLoading = false;
        this.closedTicketsCountLoading = false;
        this.sharedWithYouCountLoading = false;
        this.sharedByYouCountLoading = false;
      }
    },
    openPublication(publication) {
      window.open(publication.fileURL);
    },
    goToClosedTickets() {
      this.$router.push({
        name: "HelpDeskRequests",
        query: {
          showClosed: true,
        },
      });
    },
  },
};
</script>

<style>
.dashboard-loading {
  max-width: 100px;
  margin-bottom: 0px;
  margin-top: 12px;
}
.right-dashboard-col {
  display: flex;
}
.right-dashboard-stack {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.shared-files-card {
  margin-bottom: 8px;
}
.pay-uta-card {
  margin-top: auto;
}
</style>
